import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const rupee = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

// Resize/compress remote stock images to cut page weight
export function optimg(url, w = 800, q = 70) {
  if (!url || typeof url !== "string") return url;
  if (url.includes("images.unsplash.com")) {
    const base = url.split("?")[0];
    return `${base}?auto=format&fit=crop&w=${w}&q=${q}`;
  }
  if (url.includes("images.pexels.com")) {
    const base = url.split("?")[0];
    return `${base}?auto=compress&cs=tinysrgb&w=${w}`;
  }
  return url;
}
